import React from 'react';
import PropTypes from 'prop-types';
import {compose, graphql} from 'react-apollo';
import ForgottenPassword from './ForgottenPassword';
import NewPassword from './NewPassword';
import {logGraphQLError} from "helpers/errors";
import {generateUrl, routes} from "helpers/routes";
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

import Loading from "components/Loading";

import ForgottenPasswordTokenValidQuery from 'gql/operator/forgottenPasswordTokenValid.gql';
import ForgottenPasswordTokenDispatchMutation from 'gql/operator/forgottenPasswordTokenDispatch.gql';
import ForgottenPasswordSetNewMutation from 'gql/operator/forgottenPasswordSetNew.gql';

class ForgottenPasswordProvider extends React.Component {
    static propTypes = {
        forgottenPasswordTokenDispatch: PropTypes.func.isRequired,
        forgottenPasswordSetNew: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.dispatchPassword = this.dispatchPassword.bind(this);
        this.setNewPassword = this.setNewPassword.bind(this);
    }

    componentWillMount() {
        this.initToken(this.props);
    }

    initToken(props) {
        const {location} = props;

        const tokenHashArray = location.hash.substr(1).match(/token=[a-zA-Z0-9]*/);
        const tokenHash = tokenHashArray ? tokenHashArray[0].substr(6) : null;

        this.setState({
            token: tokenHash,
            loading: false,
            passwordTokenDispatchState: null,
            passwordChangedState: null
        });
    }

    dispatchPassword(formSubmit) {
        const {email} = formSubmit;

        this.setState({
            loading: true
        });

        this.props.forgottenPasswordTokenDispatch({
            variables: {email}
        }).then((response) => {
            console.log(response);

            this.setState({
                passwordTokenDispatchState: response.data.operatorResetPassword,
                loading: false
            });
        }).catch((error) => {
            logGraphQLError(error);

            this.setState({
               passwordTokenDispatchState: false,
                loading: false
            });
        });
    }

    setNewPassword(formSubmit) {
        const {new_password: newPassword} = formSubmit;
        const {token} = this.state;

        this.props.forgottenPasswordSetNew({
            variables: {
                newPassword,
                token
            }
        }).then((response) => {
            this.setState({
                passwordChangedState: true
            });
        }).catch((error) => {
            logGraphQLError(error);

            this.setState({
                passwordChangedState: false
            });
        });
    }

    render() {
        const {forgottenPasswordTokenValidQuery} = this.props;

        const {token, loading, passwordTokenDispatchState, passwordChangedState} = this.state;

        if (token) {
            if (forgottenPasswordTokenValidQuery.loading) {
                return <Loading/>
            }

            if (forgottenPasswordTokenValidQuery.variables.token !== this.state.token) {
                forgottenPasswordTokenValidQuery.refetch({
                    token: this.state.token
                })
            }

            let status = null;

            if (passwordChangedState) {
                status = {
                    type: 'success',
                    message: <FormattedHTMLMessage id="forgotten_password.password_changed"
                                                   defaultMessage="Your password has been successfully changed.  <a href={loginUrl}>You can now log in</a>."
                                                   values={{loginUrl: generateUrl(routes.login)}}/>
                }
            } else if (!forgottenPasswordTokenValidQuery.isTokenValid) {
                status = {
                    type: 'danger',
                    message: <FormattedMessage id="forgotten_password.invalid_token"
                                               defaultMessage="Invalid password reset token."/>
                }
            }

            return (
                <NewPassword onFormSubmit={this.setNewPassword} status={status}/>
            );
        }

        let status = null;

        if (passwordTokenDispatchState === true) {
            status = {
                type: 'success',
                message: <FormattedMessage id="forgotten_password.success"
                                           defaultMessage="The password reset token has been sent to the provided e-mail address."/>
            }
        } else if (passwordTokenDispatchState === false) {
            status = {
                type: 'danger',
                message: <FormattedMessage id="forgotten_password.failure"
                                           defaultMessage="The password reset token could not be dispatched to the provided e-mail address."/>
            }
        }

        return (
            <ForgottenPassword onFormSubmit={this.dispatchPassword} status={status} loading={loading}/>
        );
    }
}

export default compose(
    graphql(ForgottenPasswordTokenValidQuery, {
        name: 'forgottenPasswordTokenValidQuery',
        options: {
            variables: {
                token: ''
            },
            delay: true
        }
    }),
    graphql(ForgottenPasswordTokenDispatchMutation, {
        name: 'forgottenPasswordTokenDispatch'
    }),
    graphql(ForgottenPasswordSetNewMutation, {
        name: 'forgottenPasswordSetNew'
    })
)(ForgottenPasswordProvider);


// WEBPACK FOOTER //
// ./src/containers/ForgottenPassword/index.jsx